import Vue from "vue";
import Router from "vue-router";

import Home from "@/views/Home.vue";
import About from "@/views/About.vue";
import Categories from "@/views/Categories.vue";
import Listings from "@/views/Listings.vue";
import Search from "@/views/Search.vue";
import Listing from "@/views/Listing.vue";
import Admin from "@/views/Admin.vue";
import AdminDashboard from "@/views/admin/AdminDashboard.vue";
import ChangePassword from "@/views/admin/ChangePassword.vue";
import AdminCategories from "@/views/admin/AdminCategories.vue";
import AdminListings from "@/views/admin/AdminListings.vue";
import AdminServices from "@/views/admin/AdminServices.vue";
import AdminSponsors from "@/views/admin/AdminSponsors.vue";
import AdminSearches from "@/views/admin/AdminSearches.vue";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      name: "Home",
      component: Home
    },
    {
      path: "/about",
      name: "About",
      component: About
    },
    {
      path: "/categories",
      name: "Categories",
      component: Categories
    },
    {
      path: "/categories/:categoryId",
      name: "Listings",
      component: Listings
    },
    {
      path: "/search/:searchTerm",
      name: "Search",
      component: Search
    },
    {
      path: "/listing/:id",
      name: "listing",
      component: Listing
    },
    {
      path: "/admin",
      component: Admin,
      children: [
        {
          path: "/",
          name: "Admin-Dashboard",
          component: AdminDashboard
        },
        {
          path: "change-password",
          name: "Change-Password",
          component: ChangePassword
        },
        {
          path: "categories",
          name: "Admin-Categories",
          component: AdminCategories
        },
        {
          path: "listings",
          name: "Admin-Listings",
          component: AdminListings
        },
        {
          path: "services",
          name: "Admin-Services",
          component: AdminServices
        },
        {
          path: "sponsors",
          name: "Admin-Sponsors",
          component: AdminSponsors
        },
        {
          path: "searches",
          name: "Admin-Searches",
          component: AdminSearches
        },
        {
          path: "*",
          redirect: "/admin"
        }
      ]
    },
    {
      path: "*",
      redirect: "/"
    }
  ]
});
